import React, { useState } from "react"
import styled from "styled-components"

import CarouselTab from "./CarouselTab"
import CarouselHeader from "./CarouselHeader"
import CarouselBody from "./CarouselBody"
import CarouselSelectionOptions from "./CarouselSelectionOptions"

const StyledCarousel = styled.div`
  width: var(--full-width);
  min-height: 0;
  font-size: 0.9rem;

  display: flex;
  flex-direction: column;
`

type Props = {
  left: CarouselTab
  center: CarouselTab
  right: CarouselTab
  defaultTab?: CarouselSelectionOptions
}

const Carousel = ({left, center, right,
                  defaultTab=CarouselSelectionOptions.LEFT
                  }: Props) => {
  const [currentTab, setCurrentTab] = useState(defaultTab)
  
  const setActiveTab = (column: CarouselSelectionOptions) => {
    setCurrentTab(column)
  }
  
  return (
    <StyledCarousel>
      <CarouselHeader
        left={left.header}
        center={center.header}
        right={right.header}
        selected={currentTab}
        setActiveTab={setActiveTab} 
      />
      <CarouselBody
        left={left.body}
        center={center.body}
        right={right.body}
        selected={currentTab}
      />
    </StyledCarousel>
  )
}

export default Carousel